module.exports = __webpack_public_path__ + "img/title.de0d10ea.png";